import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsUserService } from '../services/mps-user.service';
import { MpsUser } from '../../app/models/mps-user.model';

export const MpsIsAdminGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl('/form');
  }

  const user = new MpsUser(loggedInUser);
  return user && user.isAdmin() ? true : router.navigateByUrl('/form');
};
